import React, { Fragment, useEffect, useRef, useState } from "react";
import './main.css'
import mainBanner from "assets/images/store_main_banner.jpg"
import bottomBanner from "assets/images/store_bottom_banner.jpg"
import storeSvg1 from "assets/images/svg/store_svg1.svg"
import storeSvg2 from "assets/images/svg/store_svg2.svg"
import storeSvg3 from "assets/images/svg/store_svg3.svg"
import storeSvg4 from "assets/images/svg/store_svg4.svg"
import storeSvg5 from "assets/images/svg/store_svg5.svg"
import storeSvg6 from "assets/images/svg/store_svg6.svg"
import storeSvg7 from "assets/images/svg/store_svg7.svg"
import storeSvg8 from "assets/images/svg/store_svg8.svg"
import storeSvg9 from "assets/images/svg/store_svg9.svg"
import storeSvg10 from "assets/images/svg/store_svg10.svg"
import storeSvg11 from "assets/images/svg/store_svg11.svg"
import storeSvg12 from "assets/images/svg/store_svg12.svg"
import storeSvg13 from "assets/images/svg/store_svg13.svg"
import storeSvg14 from "assets/images/svg/store_svg14.svg"
import storeSvg15 from "assets/images/svg/store_svg15.svg"
import simpleArrow from "assets/images/svg/store_simple_arrow.svg"
import correspondent1 from "assets/images/correspondent1.png";
import correspondent2 from "assets/images/correspondent2.png";
import correspondent3 from "assets/images/correspondent3.png";
import correspondent4 from "assets/images/correspondent4.png";
import correspondent5 from "assets/images/correspondent5.png";
import correspondent6 from "assets/images/correspondent6.png";
import correspondent7 from "assets/images/correspondent7.png";
import correspondent8 from "assets/images/correspondent8.png";
import correspondent9 from "assets/images/correspondent9.png";
import correspondent10 from "assets/images/correspondent10.png";
import correspondent11 from "assets/images/correspondent11.png";
import correspondent12 from "assets/images/correspondent12.png";
import correspondent13 from "assets/images/correspondent13.png";
import correspondent14 from "assets/images/correspondent14.png";
import correspondent15 from "assets/images/correspondent15.png";
import correspondent16 from "assets/images/correspondent16.png";
import correspondent17 from "assets/images/correspondent17.png";
import correspondent18 from "assets/images/correspondent18.png";
import correspondent19 from "assets/images/correspondent19.png";
import correspondent20 from "assets/images/correspondent20.png";
import correspondent21 from "assets/images/correspondent21.png";
import correspondent22 from "assets/images/correspondent22.png";
import correspondent23 from "assets/images/correspondent23.png";
import { saveStoreEntryContactData } from "crud/contact.crud";
import SweetAlert from "react-bootstrap-sweetalert";

const StoreEntryInformation = () => {
  const [inquryType, setInquiryType] = useState('O')
  const [company, setCompany] = useState('')
  const [manager, setManager] = useState('')
  const [localPart, setLocalPart] = useState('') // 이메일 앞부분
  const [domain, setDomain] = useState('') // 이메일 뒷부분
  const [frontPhoneNumber, setFrontPhoneNumber] = useState('010')
  const [middlePhoneNumber, setMiddlePhoneNumber] = useState('')
  const [backPhoneNumber, setBackPhoneNumber] = useState('')
  const [content, setContent] = useState('')
  const [certificateFiles, setCertificateFiles] = useState([])
  const [isAgree, setIsAgree] = useState(false)
  const [modalShow, setModalShow] = useState({
    contact : false,
    service : false
  });    
  const [alertTitle, setAlertTitle] = useState({
    contact : '',
    service : ''
  });
  const [faqOpen, setFaqOpen] = useState([true, true, true])
  const boxRefs = useRef([]);
  const divRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {    
            entry.target.classList.add("ropik-show");        
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    divRefs.current.forEach((div) => {
      if (div) observer.observe(div);
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 2차원 → 1차원으로 평탄화 후 index 구하기
            const flatRefs = boxRefs.current.flat();
            const index = flatRefs.indexOf(entry.target);

            setTimeout(() => {
              entry.target.classList.add("ropik-show");
            }, index * 100); // 0.3초 간격

            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    // 2차원 배열 각각 순회하며 observer 등록
    boxRefs.current.forEach((row) => {
      row.forEach((div) => {
        if (div) observer.observe(div);
      });
    });

    return () => observer.disconnect();
  }, []);

  const registCertificate = (files) => {
    setCertificateFiles(files);
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({...prev, [key] : true}))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({...prev, [key] : false}))
  }

  const writeAlertTitle = (key, title) => {
    setAlertTitle(prev => ({...prev, [key] : title}))
  }

  const isContactValid = () => {
    if(!inquryType){
      writeAlertTitle('contact', '문의 유형을 선택해 주세요')
      modalOpen('contact')
      return false
    }else if(!company){
      writeAlertTitle('contact', '업체명을 입력해 주세요')
      modalOpen('contact')
      return false
    }else if(!(frontPhoneNumber && middlePhoneNumber && backPhoneNumber)){
      writeAlertTitle('contact', '담당자 연락처를 입력해 주세요')
      modalOpen('contact')
      return false
    }else if(!(localPart && domain)){
      writeAlertTitle('contact', '이메일을 입력해 주세요')
      modalOpen('contact')
      return false
    }else if(!content){
      writeAlertTitle('contact', '문의내용을 입력해 주세요')
      modalOpen('contact')
      return false
    }else if(!isAgree){
      writeAlertTitle('contact', '개인정보 활용 동의에 체크해 주세요')
      modalOpen('contact')
      return false
    }
    return true;
  }

  const saveContact = async (e) =>{
    e.preventDefault()
    if(isContactValid()){
      writeAlertTitle('contact', '문의가 접수되었습니다')
      try {
        const fd = new FormData();  
        const contactData = {
          type : inquryType,
          company : company,
          manager : manager,
          manager_phone : frontPhoneNumber + middlePhoneNumber + backPhoneNumber,
          email : localPart + '@' + domain,
          content : content,
          status : 'Y'
        }
        fd.append('contact_data', JSON.stringify(contactData))
        Array.from(certificateFiles).forEach((v, i) => {
          let newFile = new File([v], encodeURI(v.name), { type: v.type });
          fd.append('file_' + i, newFile);
        });
        const response = await saveStoreEntryContactData(fd);
        if (response.data.code === '0000') {
          setInquiryType('O')
          setCompany('')
          setManager('')
          setFrontPhoneNumber('010')
          setMiddlePhoneNumber('')
          setBackPhoneNumber('')
          setLocalPart('')
          setDomain('')
          setContent('')
          modalOpen('contact')
          setCertificateFiles([])
        } else {
          writeAlertTitle('contact', '문의접수 실패! 관리자에게 문의해주세요.')
          modalOpen('contact')
        }
      } catch (error) {
        writeAlertTitle('contact', '문의접수 실패! 관리자에게 문의해주세요.')
        modalOpen('contact')
        console.error(error);
      }
    }
  }

  const procedureGuide = [
    {
      title: '배출자',
      color: '#30B2A0',
      content : [
        {title: '플랫폼 회원 가입', icon: storeSvg1},
        {title: '앱설치&수집운반\n업체 선택&단가협의', icon: storeSvg2},
        {title: '전자계약 체결', icon: storeSvg3},
        {title: '서비스 이용', icon: storeSvg4},
      ]
    },
    {
      title: '수집운반업체',
      color: '#8067D8',
      content : [
        {title: '회원 가입 신청\n(승인 심사)', icon: storeSvg1},
        {title: '앱설치&전자계약\n체결', icon: storeSvg3},
        {title: '스마트 계측기 및\n플랫폼 사용 교육', icon: storeSvg5},
        {title: '배출자 등록', icon: storeSvg6},
        {title: '서비스 이용', icon: storeSvg4},
      ]
    },
    {
      title: '처리장',
      color: '#F37172',
      content : [
        {title: '회원 가입 신청\n(승인 심사)', icon: storeSvg1},
        {title: '앱설치&전자계약\n체결', icon: storeSvg3},
        {title: '서비스 이용', icon: storeSvg4},
      ]
    },
  ]

  const inquiryMenu = [
    {
      key: "O",
      title: "입점 및 제휴문의",
      icon: storeSvg7,
    },
    {
      key: "S",
      title: "서비스 이용 문의",
      icon: storeSvg8,
    },
    {
      key: "E",
      title: "장애/불편고",
      icon: storeSvg9,
    },
    {
      key: "A",
      title: "광고 및 기타 문의",
      icon: storeSvg10,
    },
  ];

  const faq = [
    {
      q: '웨이스트버스는?',
      a: 'IoT 기술 기반 음식물류폐기물 스마트 수거 플랫폼 “웨이스트버스”는 전국에서 배출되는 음식물쓰레기에 대한 수집 및 처리, 재활용에 대한 유통 플랫폼으로 배출자와 수거운반업체, 처리업체, 수요기업간의 중개서비스를 지원함으로써 모두 상생할 수 있는 플랫폼을 구축하고, 이를 통해 자원순환 및 지속 가능한 환경을 조성하는 ESG 통합 플랫폼 입니다.'
    },
    {
      q: '서비스 이용료는?',
      a: '배출자는 부담하는 비용이 없습니다. 음식물수집운반업체는 IoT 디바이스를 무상 제공하며 플랫폼 이용액이 월정액으로 부과됩니다.'
    },
    {
      q: '타 업체와의 차이점은?',
      a: '정확한 계측 없이 사진 촬영 후 수기로 입력하던 기존 아나롤그 방식과는 달리 전세계 최초 자체 기술로 개발한 휴대용 음식물쓰레기 부피측정용 스마트 디바이스를 통한 정확한 음식물 실 배출량 계측을 통한 투명한 실비정산을 지원하며, 전국에서 배출되는 음식물쓰레기에 대한 수집, 운반 및 처리 전 과정에 대한 비대면 영업, 홍보, 계약(전자계약 지원), 정산(세금계산서 발행, 수금), 서류업무(올바로 API연동, 신고업무) 등을 배출자, 수집운반업체, 처리장업체에 제반 업무의 디지털화 지원 및 GPS를 장착한 TMS(차량관제시스템)를 통한 실시간 차량이동 현황 조회가 가능한 차별화된 플랫폼 서비스를 제공합니다.\n배출자에게는 실 배출량에 대한 청구로 비용절감 및 홍보 효과, 수집운반업체, 처리장에게는 고객 및 물량 확보를 통한 매출 및 수익 향상, 제반 업무 디지털화를 통한 비용절감효과, 수요기업에는 재생원료의 거래활성화를 지원하는 상생플랫폼입니다. 매출 및 수익 향상, 제반 업무 디지털화를 통한 비용절감효과, 수요기업에는 재생원료의 거래활성화를 지원하는 상생플랫폼입니다.'
    },
  ]

  const correspondent = [
    { img: correspondent1, width: 108, height: 60 },
    { img: correspondent2, width: 110, height: 41 },
    { img: correspondent3, width: 110, height: 36 },
    { img: correspondent4, width: 113, height: 55 },
    { img: correspondent5, width: 123, height: 27 },
    { img: correspondent6, width: 122, height: 29 },
    { img: correspondent7, width: 125, height: 42 },
    { img: correspondent8, width: 66, height: 39 },
    { img: correspondent9, width: 104, height: 25 },
    { img: correspondent10, width: 128, height: 27 },
    { img: correspondent11, width: 120, height: 27 },
    { img: correspondent12, width: 69, height: 41 },
    { img: correspondent13, width: 136, height: 49 },
    { img: correspondent14, width: 112, height: 40 },
    { img: correspondent15, width: 117, height: 51 },
    { img: correspondent16, width: 111, height: 39 },
    { img: correspondent17, width: 134, height: 48 },
    { img: correspondent18, width: 112, height: 40 },
    { img: correspondent19, width: 88, height: 40 },
    { img: correspondent20, width: 107, height: 62 },
    { img: correspondent21, width: 101, height: 68 },
    { img: correspondent22, width: 112, height: 40 },
    { img: correspondent23, width: 130, height: 55 },
  ];
  
  const text1 = '스마트 음식물 쓰레기 관리의 시작, 웨이스트버스 플랫폼 과 지금 함께하세요!';
  const text2 = '실시간 데이터와 혁신 기술로 음식물류 폐기물 관리의 효율성과 투명성을 높이는 통합 플랫폼입니다.';

  const useWordAnimation = (text, timeout = 0, delay = 100) => {
    const textArray = text.split(' ');
    const [animatedIndices, setAnimatedIndices] = useState([]);

    useEffect(() => {
      let index = 0;
      let intervalId
      const timeoutId = setTimeout(() => {
      const interval = setInterval(() => {
        setAnimatedIndices((prev) => [...prev, index]);
        index++;
        if (index >= textArray.length) {
          clearInterval(interval);
        }
      }, delay);
    }, timeout)

      return () => {
        clearTimeout(timeoutId)
        clearInterval(intervalId)
      };
    }, [text]);

    return { textArray, animatedIndices };
  }

  const { textArray: animationTextArray1, animatedIndices: animatedIndices1 } = useWordAnimation(text1);
  const { textArray: animationTextArray2, animatedIndices: animatedIndices2 } = useWordAnimation(text2);

  return (
    <Fragment>
      <section id="sec_3_1" className="store-section" style={{ position: "relative", width: '100%', backgroundImage: `url(${mainBanner})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000066', zIndex: 1}}></div>
        <div className="store-main-text-container">
          <p>
          {animationTextArray1.map((letter, index) => (
            <Fragment key={letter + index}>
              <span
                className={`${animatedIndices1.includes(index) ? 'text-animated' : 'opacity-0'} store-main-text-1`}
                style={{ color: ['웨이스트버스', '플랫폼'].includes(letter) ? '#45C2B1' : 'white' }}
              >
                {letter === '플랫폼' ? letter : letter + '\u00A0'}
              </span>
              {index === 4 && <br />}
            </Fragment>
          ))}
          </p>
          <p style={{marginTop: 20}}>
          {animationTextArray2.map((letter, index) => (
            <Fragment key={letter + index}>
              <span
                className={`${animatedIndices2.includes(index) ? 'text-animated' : 'opacity-0'} store-main-text-2`}
              >
                {letter + '\u00A0'}
              </span>
              {index === 7 && <br />}
            </Fragment>
          ))}
          </p>
        </div>
      </section>
      <div id="sec_3_2" className="entry-info-container">
        <div className="inner-container entry-info-flex-container">
          <div>
            <p style={{fontWeight: '700', fontSize: 40, lineHeight: '140%', color: '#1F2D3D'}}>플랫폼 입점<br />절차안내</p>
            <p style={{fontWeight: '600', fontSize: 18, lineHeight: '150%', color: '#1F2D3D', marginTop: 20}}>웨이스트버스 플랫폼 사용자별<br />입점절차 안내드립니다.</p>
          </div>
          <div className="entry-guide-container">
            {procedureGuide.map((item, index) => (
              <div key={'procedure_guide_'+index} style={{marginBottom: 20}}>
                <p style={{color: item.color, fontWeight: '600', fontSize: 16, lineHeight: '150%'}}>{item.title}</p>
                <div className="entry-guide-item-container">
                  {item.content.map((subItem, subIndex) => (
                    <Fragment key={'procedure_guide_sub_'+subIndex}>
                    <div ref={(el) => {
                        if (!boxRefs.current[index]) {
                          boxRefs.current[index] = [];
                        }
                        boxRefs.current[index][subIndex] = el;
                      }} 
                      className={`ropik-fade-up2`} style={{width: 150, height: 140, borderRadius: 12, padding: '19.5px 20px 20px 10.5px', backgroundColor: 'white', display: "flex", flexDirection: 'column', justifyContent: 'space-between'}}>
                      <div style={{display: 'flex', fontWeight: '500', fontSize: 14, lineHeight: '130%', letterSpacing: '-0.03em', color: '#1F2D3D'}}>
                        <p>{subIndex + 1}.&nbsp;</p>
                        <p style={{whiteSpace: "nowrap"}}>
                          {subItem.title.split('\n').map((line, i) => (
                            <Fragment key={line + i}>
                              {line}
                              <br />
                            </Fragment>
                          ))}
                        </p>
                      </div>
                      <img style={{width: 40, height: 40, alignSelf: 'flex-end'}} src={subItem.icon} />
                    </div>
                    {item.content.length !== subIndex + 1 &&
                    <div className="simple-arrow-container">
                      <img src={simpleArrow} />
                    </div>
                    }
                    </Fragment>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div id="sec_3_3" className="store-bottom-container" style={{ position: "relative", paddingTop: 120}}>
          <div ref={(el) => (divRefs.current[0] = el)} className={`ropik-fade-up`} style={{width: '100%', textAlign: 'center', color: '#1F2D3D'}}>
            <p style={{fontWeight: '700', fontSize: 40, lineHeight: '150%'}}>문의하기</p>
            <p style={{fontWeight: '600', fontSize: 18, lineHeight: '150%', marginTop: 20}}>사업 제휴/제안뿐만 아니라 서비스 이용 문의, 장애/불편신고, 광고 마케팅 제휴 등 다양한 문의를 기다립니다.<br />웨이스트버스 플랫폼으로 펼칠 수 있는 새로운 가능성을 함께 만들어 보세요.</p>
          </div>
          <div style={{width: '100%', marginTop: 50}}>
            <div ref={(el) => (divRefs.current[1] = el)} className={`ropik-fade-up`} style={{display: "flex", justifyContent: 'space-between'}}>
              <p className="" style={{fontSize: 36, lineHeight: '130%', color: '#1F2D3D'}}>웨이스트버스 플랫폼과<br /><span style={{fontWeight: '700', color: '#22B5A1'}}>미래를 만들어 보세요.</span></p>
              <div className="inquiry-procedure-container">
                {inquiryMenu.map((item, index) => (
                  <div key={'inquiry_menu_'+index} style={{width: 138, height: 88, borderWidth: `0 1px 0 ${index === 0 ? '1' : '0'}px`, borderStyle: 'solid', borderColor: '#E5EAF3', display: "flex", flexDirection: 'column', alignItems: "center"}}>
                    <p style={{fontWeight: '500', fontSize: 14, lineHeight: '130%',color: '#00B39B'}}>0{index + 1}</p>
                    <p style={{fontWeight: '500', fontSize: 14, lineHeight: '130%',color: '#707E92', marginTop: 2}}>{item.title}</p>
                    <img style={{width: 40, height: 40, marginTop: 10}} src={item.icon} />
                  </div>
                ))}
              </div>
            </div>
            <div ref={(el) => (divRefs.current[2] = el)} className={`ropik-fade-up`} style={{marginTop: 20, width: '100%'}}>
              <div className="inquiry-mobile">
                <div>
                  <p style={{fontSize: 15}}>문의 유형<span style={{color: '#22B5A1'}}>&nbsp;*</span></p>
                  <select id="front-phone-number" style={{width: '100%', height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '0 16px', marginTop: 6}} value={inquryType} onChange={(e) => {
                    setInquiryType(e.target.value)
                  }}>
                  {inquiryMenu.map((item, index) => (
                    <option key={'inquiry_radio_mobile_'+index} value={item.key}>
                      {item.title}
                    </option>
                  ))}
                  </select>
                </div>
                <div style={{marginTop: 16}}>
                  <p style={{fontSize: 15}}>업체명<span style={{color: '#22B5A1'}}>&nbsp;*</span></p>
                  <input id="company-name" style={{width: '100%', height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px', marginTop: 6}} value={company} onChange={(e) => {
                    setCompany(e.target.value)
                  }}/>
                </div>
                <div style={{marginTop: 16}}>
                  <p style={{fontSize: 15}}>담당자명</p>
                  <input id="manager-name" style={{width: '100%', height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px', marginTop: 6}} value={manager} onChange={(e) => {
                    setManager(e.target.value)
                  }}/>
                </div>
                <div style={{marginTop: 16}}>
                  <p style={{fontSize: 15}}>담당자 연락처<span style={{color: '#22B5A1'}}>&nbsp;*</span></p>
                  <div style={{display: "flex", gap: 10, marginTop: 6}}>
                    <select id="front-phone-number" style={{width: 100, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '0 16px'}} value={frontPhoneNumber} onChange={(e) => {
                      setFrontPhoneNumber(e.target.value)
                    }}>
                      <option value={'010'}>010</option>
                    </select>
                    <input id="middle-phone-number" style={{width: 100, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={middlePhoneNumber} onChange={(e) => {
                      setMiddlePhoneNumber(e.target.value)
                    }}/>
                    <input id="back-phone-number" style={{width: 100, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={backPhoneNumber} onChange={(e) => {
                      setBackPhoneNumber(e.target.value)
                    }}/>
                  </div>
                </div>
                <div style={{marginTop: 16}}>
                  <p style={{fontSize: 15}}>이메일<span style={{color: '#22B5A1'}}>&nbsp;*</span></p>
                  <div style={{display: "flex", gap: 10}}>
                    <input id="local-part" style={{width: 144, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={localPart} onChange={(e) => {
                      setLocalPart(e.target.value)
                    }} />
                    <p style={{lineHeight: '44px'}}>@</p>
                    <input id="domain" style={{width: 144, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={domain} onChange={(e) => {
                      setDomain(e.target.value)
                    }} />
                  </div>
                </div>
                <div style={{marginTop: 16}}>
                  <p style={{fontSize: 15}}>문의내용<span style={{color: '#22B5A1'}}>&nbsp;*</span></p>
                  <textarea id="inquiry-content" style={{width: '100%', height: 260, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} placeholder="문의 내용을 입력하세요." value={content} onChange={(e) => {
                    setContent(e.target.value)
                  }} />
                </div>
              </div>
              <table className="inquiry-table">
                <tbody style={{color: '#1F2D3D'}}>
                  <tr style={{height: 66, borderTop: '1px solid #86909C', borderBottom: '1px solid #EAEAEA'}}>
                    <td style={{width: 200, fontWeight: '600', fontSize: 15, lineHeight: '20px', letterSpacing: -0.5, paddingLeft: 20}}>문의 유형<span style={{color: '#22B5A1'}}>&nbsp;*</span></td>
                    <td style={{width: 1000, paddingLeft: 20}}>
                      <div style={{display: "flex", gap: 20, alignItems: "center"}}>
                        {inquiryMenu.map((item, index) => (
                          <div key={'inquiry_radio_'+index} style={{display: "flex", gap: 8, alignItems: "center"}}>
                            <input id={item.key} className="custom-radio" type="radio" name="inquiry_radio" checked={item.key === inquryType} onChange={() => {
                              setInquiryType(item.key)
                            }} />
                            {item.key === inquryType ?
                              <label style={{fontWeight: '600', fontSize: 15, lineHeight: '150%', color: '#22B5A1'}} htmlFor={item.key}>{item.title}</label>
                              :
                              <label style={{fontSize: 15, lineHeight: '150%', color: '#1F2D3D'}} htmlFor={item.key}>{item.title}</label>
                            }
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                  <tr style={{height: 66, borderBottom: '1px solid #EAEAEA'}}>
                    <td style={{width: 200, fontWeight: '600', fontSize: 15, lineHeight: '20px', letterSpacing: -0.5, paddingLeft: 20}}>업체명<span style={{color: '#22B5A1'}}>&nbsp;*</span></td>
                    <td style={{width: 1000, paddingLeft: 20}}>
                      <input id="company-name" style={{width: 500, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={company} onChange={(e) => {
                        setCompany(e.target.value)
                      }}/>
                    </td>
                  </tr>
                  <tr style={{height: 66, borderBottom: '1px solid #EAEAEA'}}>
                    <td style={{width: 200, fontWeight: '600', fontSize: 15, lineHeight: '20px', letterSpacing: -0.5, paddingLeft: 20}}>담당자명</td>
                    <td style={{width: 1000, paddingLeft: 20}}>
                      <input id="manager-name" style={{width: 500, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={manager} onChange={(e) => {
                        setManager(e.target.value)
                      }}/>
                    </td>
                  </tr>
                  <tr style={{height: 66, borderBottom: '1px solid #EAEAEA'}}>
                    <td style={{width: 200, fontWeight: '600', fontSize: 15, lineHeight: '20px', letterSpacing: -0.5, paddingLeft: 20}}>담당자 연락처<span style={{color: '#22B5A1'}}>&nbsp;*</span></td>
                    <td style={{width: 1000, paddingLeft: 20}}>
                      <div style={{display: "flex", gap: 10}}>
                        <select id="front-phone-number" style={{width: 100, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '0 16px'}} value={frontPhoneNumber} onChange={(e) => {
                          setFrontPhoneNumber(e.target.value)
                        }}>
                          <option value={'010'}>010</option>
                        </select>
                        <input id="middle-phone-number" style={{width: 100, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={middlePhoneNumber} onChange={(e) => {
                          setMiddlePhoneNumber(e.target.value)
                        }}/>
                        <input id="back-phone-number" style={{width: 100, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={backPhoneNumber} onChange={(e) => {
                          setBackPhoneNumber(e.target.value)
                        }}/>
                      </div>
                    </td>
                  </tr>
                  <tr style={{height: 66, borderBottom: '1px solid #EAEAEA'}}>
                    <td style={{width: 200, fontWeight: '600', fontSize: 15, lineHeight: '20px', letterSpacing: -0.5, paddingLeft: 20}}>이메일<span style={{color: '#22B5A1'}}>&nbsp;*</span></td>
                    <td style={{width: 1000, paddingLeft: 20}}>
                      <div style={{display: "flex", gap: 10}}>
                        <input id="local-part" style={{width: 200, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={localPart} onChange={(e) => {
                          setLocalPart(e.target.value)
                        }} />
                        <p style={{lineHeight: '44px'}}>@</p>
                        <input id="domain" style={{width: 200, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={domain} onChange={(e) => {
                          setDomain(e.target.value)
                        }} />
                        <select id="domain-select" style={{width: 200, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '0 16px'}} value={domain} onChange={(e) => {
                          setDomain(e.target.value)
                        }}>
                          <option value={''}>직접입력</option>
                          <option value={'naver.com'}>naver.com</option>
                          <option value={'gmail.com'}>gmail.com</option>
                          <option value={'kakao.com'}>kakao.com</option>
                          <option value={'nate.com'}>nate.com</option>
                        </select>
                      </div>
                    </td>
                  </tr>
                  <tr style={{height: 66, borderBottom: '1px solid #EAEAEA'}}>
                    <td style={{width: 200, fontWeight: '600', fontSize: 15, lineHeight: '20px', letterSpacing: -0.5, paddingLeft: 20}}>문의내용<span style={{color: '#22B5A1'}}>&nbsp;*</span></td>
                    <td style={{width: 1000, padding: 20}}>
                      <textarea id="inquiry-content" style={{width: 960, height: 260, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} placeholder="문의 내용을 입력하세요." value={content} onChange={(e) => {
                        setContent(e.target.value)
                      }} />
                    </td>
                  </tr>
                  <tr style={{height: 66, borderBottom: '1px solid #EAEAEA'}}>
                    <td style={{width: 200, fontWeight: '600', fontSize: 15, lineHeight: '20px', letterSpacing: -0.5, paddingLeft: 20}}>사업자등록증 첨부</td>
                    <td style={{width: 1000, padding: '20px 16px'}}>
                      <div style={{display: "flex", gap: 10}}>
                        <input id="file-name" style={{width: 200, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} disabled value={certificateFiles?.[0]?.name} />
                        <input id="certificate" style={{display: 'none'}} type="file" onChange={(e)=>{
                          registCertificate(e.target.files)
                        }} />
                        <label style={{fontWeight: '500', fontSize: 14, lineHeight: '100%', color: '#333333', padding: '15px 16px', border: '1px solid #DDDDDD', borderRadius: 8}} htmlFor="certificate">파일첨부</label>
                      </div>
                      <div style={{display: "flex", alignItems: 'center', marginTop: 11}}>
                        <img style={{width: 16, height: 16}} src={storeSvg11} />
                        <p style={{fontSize: 14, lineHeight: '100%', color: '#86909C'}}>파일 크기는 10MB까지 지원합니다.</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="inquiry-agree-container">
              <div style={{display: 'flex', alignItems: 'center'}}>
                <label htmlFor="agreement" className="custom-checkbox-label">
                  <input id="agreement" type="checkbox" className="custom-checkbox-input" checked={isAgree} onChange={(e) => {setIsAgree(e.target.checked)}} />
                  <span className="custom-checkbox-box"></span>
                  <span htmlFor="agreement" style={{fontSize: 15, lineHeight: '150%', color: '#1F2125', marginLeft: 8}}>상담문의를 위한 개인정보 활용을 동의합니다.</span>
                </label>
                <p style={{fontSize: 15, lineHeight: '20px', color: '#1F2125', textDecoration: 'underline', letterSpacing: -0.5, marginLeft: 20, cursor: "pointer"}}>자세히보기</p>
              </div>
            </div>
            <div style={{padding: '20px 0 0', width: '100%', display: 'flex', justifyContent: "center", marginTop: 20}}>
              <div style={{display: "flex", gap: 10}}>
                <button style={{padding: 16, backgroundColor: '#E8EBEF', borderRadius: 8, border: 'none'}}>
                  <p className="inquiry-button-text" style={{color: '#1F2D3D'}}>취소</p>
                </button>
                <button style={{padding: 16, backgroundColor: '#22B5A1', borderRadius: 8, border: 'none'}} onClick={(e) => {
                  saveContact(e)
                }}>
                  <p className="inquiry-button-text" style={{color: 'white'}}>신청하기</p>
                </button>
              </div>
            </div>
            {modalShow.contact &&
              <SweetAlert
                title={<span className='justify-content-center d-flex noMargin text-black font-weight-bold font-size-18' style={{marginBottom: 10, marginTop: 10}}>
                  {alertTitle.contact}
                </span>}
                onConfirm={() => {
                  modalClose('contact')
                }}
              />
            }
            <div id="sec_3_4" ref={(el) => (divRefs.current[3] = el)} className={`ropik-zoom-in faq-container`}>
              <div style={{width: '100%', textAlign: 'center'}}>
                <p style={{fontWeight: '700', fontSize: 40, lineHeight: '150%', color: '#1F2D3D'}}>FAQ</p>
                <p style={{fontWeight: '600', fontSize: 18, lineHeight: '150%', color: '#1F2D3D', marginTop: 20}}>사용자별 자주묻는 질문과 답변을 모아두었습니다.</p>
              </div>
              <div style={{width: '100%', marginTop: 50}}>
                {faq.map((item, index) => (
                <Fragment key={'store_faq_'+index}>
                  <div style={{padding: '20px 30px', display: 'flex', alignItems: "center", gap: 20, borderWidth: `${index === 0 ? '1px' : '0'} 0 1px 0`, borderColor: '#EAEAEA', borderStyle: 'solid'}}>
                    <div style={{borderRadius: '50%', backgroundColor: '#00B39B', width: 30, height: 30, padding: '3.5px 0'}}>
                      <p style={{fontWeight: '600', fontSize: 15, lineHeight: '150%', color: "white", textAlign: "center"}}>Q</p>
                    </div>
                    <p style={{fontWeight: '600', fontSize: 16, lineHeight: '150%', color: '#1F2D3D', flex: 1}}>{item.q}</p>
                    <img style={{width: 24, height: 24, cursor: "pointer"}} src={faqOpen[index] ? storeSvg12 : storeSvg15} onClick={() => {
                      setFaqOpen(prev => prev.map((v, i) => i === index ? !v : v))
                    }} />
                  </div>
                  {faqOpen[index] &&
                  <div style={{padding: '20px 30px', display: 'flex', gap: 20, borderBottom: '1px solid #EAEAEA'}}>
                    <div style={{borderRadius: '50%', backgroundColor: '#C7CDD7', width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                      <p style={{fontWeight: '600', fontSize: 15, lineHeight: '150%', color: "white", textAlign: "center"}}>A</p>
                    </div>
                    <p style={{fontSize: 15, lineHeight: '160%', color: '#1F2D3D'}}>
                      {item.a.split('\n').map((line, i) => (
                        <Fragment key={line + i}>
                          {line}
                          <br />
                        </Fragment>
                      ))}
                    </p>
                  </div>
                  }
                </Fragment>
                ))}
              </div>
            </div>
            <div id="sec_3_5" style={{paddingBottom: 120, width: '100%'}}>
              <div className="correspondent-container">
                {correspondent.map((item, index) => (
                  <div key={'store_correspondent_'+index} className="correspondent-frame">
                    <img
                      src={item.img}
                      className="correspondent-img"
                      style={{width: item.width, height: item.height}}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
      </div>
      <section className="contact-us" style={{ backgroundImage: `url(${bottomBanner})` }}>
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000066', zIndex: 1}}></div>
        <div className="contact-us-container">
          <p style={{textAlign: "center", fontWeight: '700', fontSize: 40, lineHeight: '150%', color: 'white'}}>CONTACT US</p>
          <div className="contact-us-button-container">
            <button className="contact-us-button" onClick={() => {
              // modalOpen('service')
              // writeAlertTitle('service', '서비스 준비중입니다.')
              window.open('https://pf.kakao.com/_xffgin', '_blank');
            }}>
              <img src={storeSvg13} />
              <div style={{color: "white"}}>
                <p style={{fontWeight: '600', fontSize: 26, lineHeight: '140%'}}>카카오채널 1:1 상담</p>
                <p style={{marginTop: 2, fontWeight: '500', fontSize: 15, lineHeight: '140%'}}>(오전 9시부터 오후 6시까지 상담가능)</p>
              </div>
            </button>
            <button className="contact-us-button" onClick={() => {
              // modalOpen('service')
              // writeAlertTitle('service', '서비스 준비중입니다.')
              window.open('http://pf.kakao.com/_xffgin/chat', '_blank');
            }}>
              <img src={storeSvg14} />
              <p style={{color: "white", fontWeight: '600', fontSize: 26, lineHeight: '140%'}}>AI 챗봇 상담</p>
            </button>
          </div>
        </div>
        {modalShow.service &&
          <SweetAlert
            title={<span className='justify-content-center d-flex noMargin text-black font-weight-bold font-size-18' style={{marginBottom: 10, marginTop: 10}}>
              {alertTitle.service}
            </span>}
            onConfirm={() => {
              modalClose('service')
            }}
          />
        }
      </section>
    </Fragment>
  )
};

export default StoreEntryInformation